// https://codepen.io/melbinmathai/pen/Bwwdpp
jQuery(document).ready(function($) {

    const $window = $(window);
    const $progressBarContent = $('.js-progress-bar-content');
    const $progressBarContainer = $('.js-article-nav');
    const $progressBar = $progressBarContainer.find('.js-progress-bar');

    

    $window.on('scroll', function () {

        const wintop = $window.scrollTop();
        const docheight = $progressBarContent.height();
        const winheight = $window.height();
        const totalScroll = (wintop/(docheight-winheight))*100;

        $progressBarContainer.toggleClass('active', totalScroll > 0);

        $progressBar.css("width", totalScroll+"%");
        
    });
  
});